var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-main"},[_c('Header'),_c(_vm.pageComp,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }